enum FormType {
	Undefined                  = 0,
	WorkerTermsConditions   = 1,
	WorkerRightToWork       = 2,
	WorkerQualification     = 3,
}

export default FormType;
